<img [src]="monSrc" [alt]="monAlt" (error)="onError()" *ngIf="!hasFailedFavicon"/>
<mon-icon *ngIf="hasFailedFavicon" [icon]="['GLOBAL_POLICY_OVERVIEW', 'POLICY_EXCHANGE_CENTER', 'PAGE']"></mon-icon>